/* src/app/admin-dashboard/scheculed-task/scheculed-task.component.css */
/*# sourceMappingURL=scheculed-task.component.css.map */
